import { createUseStyles } from 'react-jss'
import S2 from '../../typography/S2'
import {AudienceModel, AudienceRequestModel} from "../../../redux/campaignTypes";

interface Props {
  audience: Extract<AudienceModel, { type: 'activeUsers' }> | undefined
  onChange: (audience: Extract<AudienceRequestModel, { type: 'activeUsers' }>) => void
}

const ActiveUsersAudienceEditor = (props: Props) => {
  const styles = useStyles()
  return (
    <div className={styles.container}>
      <S2>All active users. Recipients are determined during campaign execution.</S2>
    </div>
  )
}

export default ActiveUsersAudienceEditor

const useStyles = createUseStyles({
  container: {
    marginTop: 6
  }
})
